interface VisualProperty {
  owned_percent: number;
  type: string;
  name: string;
}

interface DummyToken {
  _id: string;
  token_id: string;
  class_type: string;
  owned_by: string;
  token_name: string;
  for_sale: boolean;
  selling_price: number;
  skills: {
    Racketeering: number;
    Shooting: number;
    Gambling: number;
    Patience: number;
    Intelligence: number;
  };
  token_uri: string;
  total_stats: number;
  visual_properties: VisualProperty[];
}

interface DummyData {
  tokens: DummyToken[];
}

export const dummyData: DummyData = {
  tokens: [
    {
      _id: "0x1a",
      token_id: "0x1a",
      class_type: "Marksman",
      owned_by: "hx1ce4f6168fbf34cb79641390def103e9d3e1ce85",
      token_name: "GangstaBet #26",
      for_sale: false,
      selling_price: 0,
      skills: {
        Racketeering: 0,
        Shooting: 0,
        Gambling: 0,
        Patience: 0,
        Intelligence: 0,
      },
      token_uri:
        "https://i3dza2pzofsyqm6oqc42qg7zkxlpke5kwdrhvzdakz3xua7uwpvq.arweave.net/RseQaflxZYgzzoC5qBv5Vdb1E6qw4nrkYFZ3egP0s-s",
      total_stats: 0,
      visual_properties: [
        {
          owned_percent: 19,
          type: "Background",
          name: "16x cards",
        },
        {
          owned_percent: 20,
          type: "Gender",
          name: "Female",
        },
        {
          owned_percent: 61,
          type: "Stance",
          name: "Far extended",
        },
        {
          owned_percent: 19,
          type: "Skin",
          name: "Human",
        },
        {
          owned_percent: 34,
          type: "Skin color",
          name: "Red",
        },
        {
          owned_percent: 39,
          type: "Outfit",
          name: "Dress shirt",
        },
        {
          owned_percent: 1,
          type: "Tie",
          name: "Necktie",
        },
        {
          owned_percent: 2,
          type: "Cufflink",
          name: "Silver",
        },
        {
          owned_percent: 53,
          type: "Shoes",
          name: "Oxfords",
        },
        {
          owned_percent: 31,
          type: "Accessories For regular stance",
          name: "Black and silver cane",
        },
        {
          owned_percent: 41,
          type: "Accessories For close extended stance",
          name: "Beer",
        },
        {
          owned_percent: 78,
          type: "Accessories For far extended stance",
          name: "Stevens M620 sawed-off",
        },
        {
          owned_percent: 45,
          type: "Hair",
          name: "pompadour with fade",
        },
        {
          owned_percent: 83,
          type: "Glasses",
          name: "Sunglasses",
        },
        {
          owned_percent: 68,
          type: "Smoking accessories",
          name: "Cigar",
        },
        {
          owned_percent: 4,
          type: "Collar and cuffs",
          name: "white collar and matching cuffs",
        },
      ],
    },
    // ... rest of the tokens would be added here
  ],
}; 